module.exports = __webpack_public_path__ + "img/rooms21.f4e1b8dd.png";